<script setup lang='ts'>
import { EyeOffSharp, EyeOutline } from '@vicons/ionicons5'
import { useApiStore } from '@/store/api'
import emitter from '@/utils/eventBus'

const { accountGetInfo } = useApiStore()
const router = useRouter()
//  个人信息
const accountInfo = ref({
  freeze: 0,
} as AccountInfo)

const showBalance = ref(false)

const options = [
  {
    label: '新建工单',
    key: 'add'
  },
  {
    label: '我的工单',
    key: 'list'
  }
]

function unFreeze() {
  window.$dialog?.info({
    title: '温馨提醒',
    content: '您好，您的账户超过一年未消费，为了资金安全已冻结金额，如需要消费请联系客服解冻。',
    positiveText: '确认',
    onPositiveClick: async () => {
    },
  })
}

async function showBalanceFn() {
  const info = await accountGetInfo()
  if (info) {
    accountInfo.value = info
    console.log('accountInfo.value: ', accountInfo.value)
  }
}

function handleSelect(key: string | number) {
  if(key === 'add') {
    router.push('/workOrder/add')
  } else if(key === 'list') {
    router.push('/workOrder/list')
  }
}

onMounted(() => {
  showBalanceFn()
  emitter.on('update-accountInfo', showBalanceFn)
})
onUnmounted(() => {
  // 组件销毁时注销事件监听，避免内存泄漏
  emitter.off('update-accountInfo', showBalanceFn)
})
</script>

<template>
  <div class="flex items-center">
    <div class="flex items-center">
      <div class="flex items-center mx-12px">
        <div class="mr-8px whitespace-nowrap">
          余额：<span>{{ showBalance ? accountInfo.freeze !== 0 ? accountInfo.freeze : accountInfo.balance : '*** ' }} </span> 元
        </div>
        <n-icon v-show="showBalance" v-track="() => ({ type: 'Icon_Button', data: '余额关闭查看', public: true })" class="cursor-pointer" size="22" :component="EyeOutline" @click="showBalance = !showBalance" />
        <!-- <n-icon v-show="!showBalance" class="cursor-pointer" size="22" :component="EyeOffSharp" @click="showBalance = !showBalance" /> -->
        <svg-icons-eyeClose v-show="!showBalance" v-track="() => ({ type: 'Icon_Button', data: '余额查看', public: true })" class="cursor-pointer text-18px" @click="showBalance = !showBalance" />
      </div>
      <router-link v-if="accountInfo.freeze === 0" v-track="{ public: true }" to="/expenseCenter/index">
        <n-button type="info" color="#1664FF" class="px-30px">
          充值
        </n-button>
      </router-link>
      <div v-if="accountInfo.freeze !== 0">
        <n-button strong secondary type="error" class="px-30px" @click="unFreeze">
          已冻结
        </n-button>
      </div>
      <n-dropdown trigger="hover" :options="options" @select="handleSelect">
        <n-button class="ml-8px">工单 ▾</n-button>
      </n-dropdown>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
